import _ from 'underscore';

export const maxHeadlineCount = 15;
export const maxDescriptionCount = 4;
export const DKIThemeDefaultName = 'Asset_Theme_For_DKI';

const rsaCollectionConfig = {
  headlines: {
    singleAssetValidationPropsField: 'Headline',
    validationPropsField: 'Headlines',
    minCollectionSize: 3,
    maxCollectionSize: maxHeadlineCount,
    inlineRecommendationsTitle: _TL_('Headlines from your website'),
    inlineRecommendationsHelpTopicKey: 'pop_BA_Recommendations_AI_ChatGPT_Headlines',
    inlineRecommendationsHelpTopicAriaLabel: _TL_('Click to learn more about headlines recommendations'),
    inlineRecommendationsDisabledItemTooltip: _TL_('You have entered the maximum number of descriptions. To add another description, remove an existing one.'),
    enableDKI: true,
    DKIThemeName: _TL_('Headline with dynamic keyword'),
  },
  descriptions: {
    singleAssetValidationPropsField: 'Description',
    validationPropsField: 'Descriptions',
    minCollectionSize: 2,
    maxCollectionSize: maxDescriptionCount,
    inlineRecommendationsTitle: _TL_('Descriptions from your website'),
    inlineRecommendationsHelpTopicKey: 'pop_BA_Recommendations_AI_ChatGPT_Descriptions',
    inlineRecommendationsHelpTopicAriaLabel: _TL_('Click to learn more about descriptions recommendations'),
    inlineRecommendationsDisabledItemTooltip: _TL_('You have entered the maximum number of descriptions. To add another description, remove an existing one.'),
  },
};

export const getTextAssetCollectionConfig = (collectionName) => {
  const unlocalizedArgs = _.result(rsaCollectionConfig, collectionName, undefined);

  if (!unlocalizedArgs) {
    throw new Error(`Invalid text asset collection name: ${collectionName}`);
  }

  const localizedArgs = {
    ...unlocalizedArgs,
  };

  return localizedArgs;
};

